__webpack_public_path__ = window.__webpack_public_path__ || process.env.ASSETS_PATH

export default __webpack_public_path__
